import { render } from "./SearchBooks.vue?vue&type=template&id=71faa056"
import script from "./SearchBooks.vue?vue&type=script&lang=js"
export * from "./SearchBooks.vue?vue&type=script&lang=js"

import "./SearchBooks.vue?vue&type=style&index=0&id=71faa056&lang=scss"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__